import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { DEFAULT_STALE_DATA_TIMEOUT } from '@AppState/app-config'
import { RootState } from '@AppState/redux-store'
import { PlayerServiceAPI } from '@API/data-services/player-service'

/** Loads players-area capability flags for the active customer (React Query, cached per customer). */
export const usePlayerCapabilities = () => {
  const { activeCustomerId } = useSelector((state: RootState) => state.users)
  return useQuery({
    queryKey: [`${activeCustomerId}-player-capabilities`],
    staleTime: DEFAULT_STALE_DATA_TIMEOUT,
    queryFn: () => PlayerServiceAPI.getPlayerCapabilities(),
  })
}
